var map = {
	"./Amazon.svg": 88582,
	"./Bonifico bancario.svg": 35354,
	"./Cash on Delivery (COD).svg": 67450,
	"./Cod (2).svg": 52072,
	"./Cod.svg": 55298,
	"./Ebay.svg": 10387,
	"./Ebay_.svg": 1751,
	"./Google_Translate_logo.svg": 14542,
	"./Magento.svg": 48485,
	"./New-Google-Ads-Logo.svg": 53110,
	"./None.svg": 52167,
	"./Other.svg": 92779,
	"./Risorsa 2.svg": 98911,
	"./Risorsa 3.svg": 64405,
	"./Risorsa 4.svg": 9385,
	"./Risorsa 5.svg": 27282,
	"./SVG/logo_1.svg": 36882,
	"./Standard.svg": 57120,
	"./ai/Claude.svg": 42569,
	"./ai/aiassistent.svg": 14951,
	"./ai/deepseek.svg": 7780,
	"./ai/gemini.svg": 68281,
	"./ai/leonardo.svg": 17878,
	"./ai/n8n-icon.svg": 3718,
	"./ai/n8n.svg": 26443,
	"./ai/openai.svg": 97559,
	"./alarm.svg": 24984,
	"./american express.svg": 25787,
	"./android.svg": 16632,
	"./androidapp.svg": 56224,
	"./androidapp_1.svg": 36561,
	"./aruba.svg": 59876,
	"./aruba_active.svg": 65155,
	"./auth/apple.svg": 98198,
	"./auth/apple_white.svg": 45305,
	"./auth/facebook-3.svg": 31106,
	"./auth/facebook.svg": 58766,
	"./auth/google-authenticator-2.svg": 46859,
	"./auth/linkedin.svg": 54016,
	"./auth/microsoft-authenticator.svg": 46348,
	"./auth/slack-new-logo.svg": 31421,
	"./auth/twiiter.svg": 97813,
	"./bank (1).svg": 25984,
	"./bank (2).svg": 49148,
	"./bank.svg": 96961,
	"./bing-merchant-center.svg": 53131,
	"./blogger.svg": 12842,
	"./box (1).svg": 69419,
	"./box (2).svg": 44935,
	"./box.svg": 73332,
	"./box_cancel.svg": 54176,
	"./box_late.svg": 17520,
	"./box_ship.svg": 17001,
	"./box_warning.svg": 77601,
	"./business-color_money-coins_icon-icons.com_53446.svg": 46885,
	"./cash on delivery cod.svg": 29011,
	"./cash-on-delivery.svg": 58655,
	"./cassa.svg": 10210,
	"./communication/firebase.svg": 31350,
	"./communication/whatsapp.svg": 38065,
	"./consigli.svg": 12220,
	"./contanti.svg": 68768,
	"./corrieri/bartolini.svg": 66946,
	"./corrieri/colli.svg": 53882,
	"./corrieri/collo2.svg": 76337,
	"./corrieri/dhl-1.svg": 43846,
	"./corrieri/dhl.svg": 75461,
	"./corrieri/fedex-express-6.svg": 13861,
	"./corrieri/fedex.svg": 49142,
	"./corrieri/gls.svg": 23774,
	"./corrieri/label.svg": 59129,
	"./corrieri/sda.svg": 65982,
	"./corrieri/shippypro.svg": 72436,
	"./corrieri/spediamo.svg": 26857,
	"./corrieri/spedisciOnline.svg": 9760,
	"./corrieri/tnt.svg": 84724,
	"./corrieri/tracking.svg": 61718,
	"./corrieri/tracking2.svg": 56683,
	"./corrieri/tracking3.svg": 91994,
	"./corrieri/tracking4.svg": 73693,
	"./corrieri/ups (1).svg": 71261,
	"./corrieri/ups.svg": 51589,
	"./creditcard.svg": 23812,
	"./error.svg": 68067,
	"./facebook-messenger.svg": 39063,
	"./fattureincloud-logo.svg": 30088,
	"./fattureincloud.svg": 81690,
	"./fattureincloud2.svg": 67092,
	"./fattureincloud_active.svg": 13393,
	"./fattureincloud_active_2.svg": 69617,
	"./file/7z.svg": 82443,
	"./file/avi.svg": 95438,
	"./file/css.svg": 22505,
	"./file/csv.svg": 19028,
	"./file/doc.svg": 74372,
	"./file/docx.svg": 74843,
	"./file/exe.svg": 38658,
	"./file/gif.svg": 10727,
	"./file/html.svg": 95583,
	"./file/iso.svg": 55814,
	"./file/jpg.svg": 78613,
	"./file/mdb.svg": 82044,
	"./file/mp3.svg": 53848,
	"./file/mp4.svg": 12031,
	"./file/pdf.svg": 69591,
	"./file/png.svg": 81552,
	"./file/ppt.svg": 96545,
	"./file/pptx.svg": 10792,
	"./file/rar.svg": 25809,
	"./file/svg.svg": 42495,
	"./file/txt.svg": 64537,
	"./file/xls.svg": 26441,
	"./file/xlsx.svg": 24622,
	"./file/zip.svg": 94718,
	"./finanza/aruba.svg": 14391,
	"./finanza/fattura24-126x40-w.svg": 20155,
	"./finanza/fattureincloud.svg": 37568,
	"./flag/006-mozambique.svg": 51705,
	"./flag/009-uganda.svg": 13750,
	"./flag/010-nigeria.svg": 45644,
	"./flag/013-tunisia.svg": 52219,
	"./flag/014-nicaragua.svg": 84124,
	"./flag/016-zambia.svg": 2441,
	"./flag/017-wales.svg": 3085,
	"./flag/019-qatar.svg": 20200,
	"./flag/020-namibia.svg": 63745,
	"./flag/022-european-union.svg": 77631,
	"./flag/024-hawaii.svg": 68777,
	"./flag/028-myanmar.svg": 43270,
	"./flag/031-pakistan.svg": 6374,
	"./flag/035-serbia.svg": 32832,
	"./flag/036-scotland.svg": 53416,
	"./flag/037-north-korea.svg": 28554,
	"./flag/038-uruguay.svg": 96817,
	"./flag/039-syria.svg": 89550,
	"./flag/046-united-nations.svg": 68747,
	"./flag/047-panama.svg": 61592,
	"./flag/057-venezuela.svg": 90716,
	"./flag/065-ukraine.svg": 14465,
	"./flag/069-laos.svg": 74239,
	"./flag/074-peru.svg": 74854,
	"./flag/080-taiwan.svg": 37712,
	"./flag/083-christmas-island.svg": 52572,
	"./flag/084-ceuta.svg": 71452,
	"./flag/088-corsica.svg": 50164,
	"./flag/089-canary-islands.svg": 50590,
	"./flag/092-cayman-islands.svg": 27284,
	"./flag/100-abkhazia.svg": 41715,
	"./flag/101-balearic-islands.svg": 3307,
	"./flag/112-british-virgin-islands.svg": 96394,
	"./flag/117-albania.svg": 41303,
	"./flag/120-basque-country.svg": 11267,
	"./flag/123-british-columbia.svg": 65491,
	"./flag/136-galapagos-islands.svg": 75463,
	"./flag/138-tonga.svg": 23270,
	"./flag/139-st-lucia.svg": 96341,
	"./flag/140-rapa-nui.svg": 20584,
	"./flag/142-palau.svg": 66249,
	"./flag/143-niue.svg": 509,
	"./flag/148-vanuatu.svg": 69459,
	"./flag/149-sierra-leone.svg": 70850,
	"./flag/150-seychelles.svg": 84519,
	"./flag/151-kosovo.svg": 27069,
	"./flag/155-orkney-islands.svg": 77994,
	"./flag/156-turks-and-caicos.svg": 53663,
	"./flag/157-transnistria.svg": 789,
	"./flag/158-tokelau.svg": 25284,
	"./flag/160-st-vincent-and-the-grenadines.svg": 15771,
	"./flag/161-south-sudan.svg": 30039,
	"./flag/162-somaliland.svg": 18372,
	"./flag/163-solomon-islands.svg": 14859,
	"./flag/164-vietnam.svg": 41946,
	"./flag/165-sint-maarten.svg": 87513,
	"./flag/166-sint-eustatius.svg": 56419,
	"./flag/167-saint-kitts-and-nevis.svg": 20845,
	"./flag/168-saba-island.svg": 16805,
	"./flag/169-pitcairn-islands.svg": 81151,
	"./flag/170-palestine.svg": 41052,
	"./flag/171-ossetia.svg": 19051,
	"./flag/172-northern-marianas-islands.svg": 51297,
	"./flag/173-nauru.svg": 85871,
	"./flag/176-melilla.svg": 6936,
	"./flag/188-virgin-islands.svg": 90760,
	"./flag/190-vatican-city.svg": 69216,
	"./flag/191-tubalu.svg": 38682,
	"./flag/192-turkmenistan.svg": 66968,
	"./flag/193-togo.svg": 13168,
	"./flag/196-azores-islands.svg": 17812,
	"./flag/197-suriname.svg": 93877,
	"./flag/198-somalia.svg": 13132,
	"./flag/199-sicily.svg": 94395,
	"./flag/200-sardinia.svg": 78669,
	"./flag/201-sao-tome-and-principe.svg": 29942,
	"./flag/202-norfolk-island.svg": 17984,
	"./flag/203-niger.svg": 87126,
	"./flag/204-micronesia.svg": 98807,
	"./flag/213-st-barts.svg": 8028,
	"./flag/214-san-marino.svg": 52701,
	"./flag/215-northen-cyprus.svg": 81547,
	"./flag/222-sahrawi-arab-democratic-republic.svg": 54721,
	"./flag/224-otan.svg": 13402,
	"./flag/226-east-timor.svg": 47504,
	"./flag/227-tibet.svg": 92014,
	"./flag/229-papua-new-guinea.svg": 7129,
	"./flag/233-madeira.svg": 67362,
	"./flag/235-trinidad-and-tobago.svg": 71640,
	"./flag/236-tajikistan.svg": 39855,
	"./flag/238-sri-lanka.svg": 57627,
	"./flag/242-zimbabwe.svg": 23472,
	"./flag/243-rwanda.svg": 53949,
	"./flag/248-samoa.svg": 36337,
	"./flag/249-nepal.svg": 85024,
	"./flag/259-senegal.svg": 6971,
	"./flag/260-paraguay.svg": 11623,
	"./flag/AD.svg": 73715,
	"./flag/AE.svg": 2812,
	"./flag/AF.svg": 87181,
	"./flag/AG.svg": 38426,
	"./flag/AI.svg": 79263,
	"./flag/AM.svg": 15836,
	"./flag/AO.svg": 65611,
	"./flag/AR.svg": 56263,
	"./flag/AS.svg": 19843,
	"./flag/AT.svg": 39963,
	"./flag/AU.svg": 99649,
	"./flag/AW.svg": 44783,
	"./flag/AX.svg": 21075,
	"./flag/AZ.svg": 65514,
	"./flag/BA.svg": 56264,
	"./flag/BB.svg": 4775,
	"./flag/BD.svg": 32930,
	"./flag/BE.svg": 99818,
	"./flag/BF.svg": 58943,
	"./flag/BG.svg": 15433,
	"./flag/BH.svg": 24026,
	"./flag/BI.svg": 69654,
	"./flag/BJ.svg": 18134,
	"./flag/BM.svg": 2768,
	"./flag/BN.svg": 781,
	"./flag/BQ.svg": 53822,
	"./flag/BR.svg": 77152,
	"./flag/BS.svg": 33003,
	"./flag/BT.svg": 32894,
	"./flag/BW.svg": 25440,
	"./flag/BY.svg": 74546,
	"./flag/BZ.svg": 12271,
	"./flag/CA.svg": 71413,
	"./flag/CC.svg": 31465,
	"./flag/CD.svg": 42103,
	"./flag/CF.svg": 7756,
	"./flag/CG.svg": 59974,
	"./flag/CH.svg": 21986,
	"./flag/CI.svg": 48900,
	"./flag/CK.svg": 9315,
	"./flag/CL.svg": 40689,
	"./flag/CM.svg": 4451,
	"./flag/CN.svg": 40491,
	"./flag/CO.svg": 89613,
	"./flag/CQ.svg": 32079,
	"./flag/CR.svg": 16289,
	"./flag/CU.svg": 69891,
	"./flag/CV.svg": 7498,
	"./flag/CW.svg": 81299,
	"./flag/CY.svg": 57382,
	"./flag/CZ.svg": 47413,
	"./flag/DE.svg": 94531,
	"./flag/DJ.svg": 48468,
	"./flag/DK.svg": 42352,
	"./flag/DM.svg": 50096,
	"./flag/DO.svg": 18418,
	"./flag/DZ.svg": 48024,
	"./flag/EC.svg": 63237,
	"./flag/EE.svg": 46427,
	"./flag/EG.svg": 82466,
	"./flag/EL.svg": 3312,
	"./flag/EN.svg": 728,
	"./flag/ER.svg": 10640,
	"./flag/ES.svg": 9065,
	"./flag/ET.svg": 15376,
	"./flag/EU.svg": 38140,
	"./flag/FI.svg": 32793,
	"./flag/FJ.svg": 58233,
	"./flag/FK.svg": 26811,
	"./flag/FO.svg": 61276,
	"./flag/FR.svg": 89251,
	"./flag/GA.svg": 17785,
	"./flag/GB.svg": 83334,
	"./flag/GD.svg": 67192,
	"./flag/GE.svg": 22191,
	"./flag/GG.svg": 18964,
	"./flag/GH.svg": 64595,
	"./flag/GI.svg": 2727,
	"./flag/GL.svg": 41297,
	"./flag/GM.svg": 81457,
	"./flag/GN.svg": 78688,
	"./flag/GR.svg": 33659,
	"./flag/GT.svg": 62346,
	"./flag/GU.svg": 66720,
	"./flag/GW.svg": 78586,
	"./flag/HK.svg": 67144,
	"./flag/HN.svg": 12784,
	"./flag/HR.svg": 16054,
	"./flag/HT.svg": 10253,
	"./flag/HU.svg": 44892,
	"./flag/ID.svg": 12425,
	"./flag/IE.svg": 6795,
	"./flag/IL.svg": 72390,
	"./flag/IM.svg": 82082,
	"./flag/IN.svg": 24024,
	"./flag/IO.svg": 51047,
	"./flag/IQ.svg": 67418,
	"./flag/IR.svg": 56879,
	"./flag/IS.svg": 92329,
	"./flag/IT.svg": 4817,
	"./flag/JE.svg": 87576,
	"./flag/JM.svg": 75947,
	"./flag/JO.svg": 3798,
	"./flag/JP.svg": 62777,
	"./flag/KE.svg": 21350,
	"./flag/KG.svg": 2042,
	"./flag/KH.svg": 94451,
	"./flag/KM.svg": 4405,
	"./flag/KR.svg": 30512,
	"./flag/KW.svg": 58552,
	"./flag/KZ.svg": 7556,
	"./flag/LB.svg": 26206,
	"./flag/LI.svg": 30868,
	"./flag/LR.svg": 15597,
	"./flag/LS.svg": 58833,
	"./flag/LT.svg": 83332,
	"./flag/LU.svg": 79747,
	"./flag/LV.svg": 87151,
	"./flag/LY.svg": 65600,
	"./flag/MA.svg": 6876,
	"./flag/MC.svg": 58444,
	"./flag/MD.svg": 99210,
	"./flag/ME.svg": 59031,
	"./flag/MG.svg": 51719,
	"./flag/MH.svg": 60456,
	"./flag/MK.svg": 72554,
	"./flag/ML.svg": 29648,
	"./flag/MN.svg": 3875,
	"./flag/MO.svg": 86764,
	"./flag/MQ.svg": 12137,
	"./flag/MR.svg": 81465,
	"./flag/MS.svg": 31033,
	"./flag/MT.svg": 97177,
	"./flag/MU.svg": 36046,
	"./flag/MV.svg": 84390,
	"./flag/MW.svg": 51610,
	"./flag/MX.svg": 67156,
	"./flag/MY.svg": 64888,
	"./flag/NL.svg": 35254,
	"./flag/NO.svg": 53036,
	"./flag/NZ.svg": 34652,
	"./flag/OM.svg": 57109,
	"./flag/PF.svg": 58261,
	"./flag/PH.svg": 46869,
	"./flag/PL.svg": 41257,
	"./flag/PR.svg": 5325,
	"./flag/PT.svg": 10251,
	"./flag/RO.svg": 40202,
	"./flag/RU.svg": 75015,
	"./flag/SA.svg": 21404,
	"./flag/SD.svg": 37390,
	"./flag/SE.svg": 88880,
	"./flag/SG.svg": 84729,
	"./flag/SI.svg": 42530,
	"./flag/SK.svg": 22263,
	"./flag/SV.svg": 48722,
	"./flag/TD.svg": 95701,
	"./flag/TH.svg": 4129,
	"./flag/TR.svg": 91677,
	"./flag/TZ.svg": 26253,
	"./flag/UK.svg": 40275,
	"./flag/US.svg": 40442,
	"./flag/UZ.svg": 92782,
	"./flag/YE.svg": 68886,
	"./flag/ZA.svg": 99364,
	"./flag/bo.svg": 77169,
	"./flag/map.svg": 15399,
	"./framework/Magento.svg": 83617,
	"./framework/bigcommerce.svg": 73848,
	"./framework/etsy.svg": 7015,
	"./framework/magento (1).svg": 62667,
	"./framework/opencart.svg": 98956,
	"./framework/oxatis.svg": 21745,
	"./framework/prestashop.svg": 51881,
	"./framework/prestashop2.svg": 4600,
	"./framework/shopify (1).svg": 56053,
	"./framework/shopify.svg": 19637,
	"./framework/squarespace.svg": 88293,
	"./framework/woocommerce (1).svg": 68088,
	"./framework/woocommerce.svg": 11446,
	"./framework/world-wide-web.svg": 80958,
	"./gift-card_1.svg": 59137,
	"./gift.svg": 26134,
	"./google-ads-2.svg": 70977,
	"./google-analytics-3.svg": 54331,
	"./google-analytics.svg": 58056,
	"./google-calendar.svg": 69089,
	"./google-cloud.svg": 96968,
	"./google-drive.svg": 11859,
	"./google-icon.svg": 46546,
	"./google-merchant-center.svg": 53862,
	"./google-tag-assistant.svg": 7243,
	"./googlemap.svg": 91090,
	"./grafici/maps.svg": 23853,
	"./green-check-mark.svg": 95347,
	"./ic_analytics.svg": 7678,
	"./ic_data_studio.svg": 58571,
	"./ic_tag_manager.svg": 58039,
	"./iconpay/amazonpay.svg": 65477,
	"./iconpay/applepay.svg": 84054,
	"./iconpay/bank.svg": 31709,
	"./iconpay/bitcoin.svg": 51368,
	"./iconpay/cashdelivery.svg": 28474,
	"./iconpay/circus.svg": 71866,
	"./iconpay/cirrus.svg": 580,
	"./iconpay/crypto.svg": 95522,
	"./iconpay/googlepay.svg": 95228,
	"./iconpay/jcb.svg": 87050,
	"./iconpay/klarna.svg": 87433,
	"./iconpay/maestro.svg": 46615,
	"./iconpay/mastercard.svg": 17408,
	"./iconpay/nexi.svg": 8051,
	"./iconpay/paypal.svg": 93806,
	"./iconpay/payshop.svg": 77706,
	"./iconpay/postepay.svg": 1196,
	"./iconpay/satisplay.svg": 86367,
	"./iconpay/scalapay.svg": 16613,
	"./iconpay/stripe.svg": 17757,
	"./iconpay/unionpay.svg": 9466,
	"./iconpay/visa.svg": 3647,
	"./iconpay/wallet.svg": 96874,
	"./inbox.svg": 13979,
	"./invoice.svg": 77868,
	"./logo.svg": 82835,
	"./maestro.svg": 45832,
	"./mail.svg": 36829,
	"./marketing/activecampaign-1.svg": 44386,
	"./marketing/analytics.svg": 40594,
	"./marketing/google-ads-2.svg": 64059,
	"./marketing/google-analytics-4.svg": 83370,
	"./marketing/google-data-studio.svg": 96901,
	"./marketing/google-merchant-center.svg": 33573,
	"./marketing/marketplace-facebook.svg": 37803,
	"./marketplace/2checkout.svg": 28922,
	"./marketplace/ASOS.com-Logo.wine.svg": 33825,
	"./marketplace/Amazon.svg": 419,
	"./marketplace/Amazon_logo.svg": 66683,
	"./marketplace/EBay_logo.svg": 93107,
	"./marketplace/Ebay.svg": 2173,
	"./marketplace/IBS_logo.svg": 2731,
	"./marketplace/LeroyMerlin.svg": 91145,
	"./marketplace/Wish_2022.svg": 24964,
	"./marketplace/Zalando_Brandmark_Orange.svg": 26080,
	"./marketplace/Zalando_Logo_Package/Zalando_Logo_Package_20240902/Zalando_Logo_Package/RGB/Brandmark/Zalando_Brandmark_Orange.svg": 99765,
	"./marketplace/Zalando_Logo_Package/Zalando_Logo_Package_20240902/Zalando_Logo_Package/RGB/Wordmark/Black/zalando_wordmark_black_RGB.svg": 22367,
	"./marketplace/Zalando_Logo_Package/Zalando_Logo_Package_20240902/Zalando_Logo_Package/RGB/Wordmark/White/zalando_wordmark_white_RGB.svg": 96867,
	"./marketplace/aliexpress.svg": 49709,
	"./marketplace/amazon-icon.svg": 81454,
	"./marketplace/bricobravo.svg": 71319,
	"./marketplace/bricobravo_icon.svg": 70925,
	"./marketplace/c05c5dc7-6fb8-4985-b4fe-daa299c22b02.svg": 46347,
	"./marketplace/commercev3.svg": 46607,
	"./marketplace/core-dna.svg": 43175,
	"./marketplace/ebay-svgrepo-com.svg": 93465,
	"./marketplace/episerver-digital-commerce.svg": 69889,
	"./marketplace/eprice.svg": 48995,
	"./marketplace/etsy.svg": 55753,
	"./marketplace/kibo-ecommerce.svg": 78734,
	"./marketplace/liferay-commerce.svg": 10738,
	"./marketplace/magento-open-source.svg": 98762,
	"./marketplace/manomano-seeklogo.svg": 73673,
	"./marketplace/manomano.svg": 11130,
	"./marketplace/manomano_icon.svg": 9281,
	"./marketplace/nopcommerce.svg": 78099,
	"./marketplace/oracle-commerce.svg": 54724,
	"./marketplace/payproglobal.svg": 41365,
	"./marketplace/salesforce-b2c-commerce.svg": 84403,
	"./marketplace/spryker.svg": 77571,
	"./marketplace/temu (2).svg": 62968,
	"./marketplace/temu.svg": 52218,
	"./marketplace/tiktok.svg": 49193,
	"./marketplace/veepee-white.svg": 24440,
	"./marketplace/virto-commerce.svg": 64092,
	"./mastercard.svg": 17914,
	"./mc_symbol.svg": 39285,
	"./meter1.svg": 46914,
	"./meter2.svg": 2066,
	"./meter3.svg": 55788,
	"./meter4.svg": 45899,
	"./microsoft-clarity.svg": 60527,
	"./microsoft.svg": 51394,
	"./mongodb.svg": 37347,
	"./newletter/4dem.svg": 44700,
	"./newletter/activecampaign.svg": 82271,
	"./newletter/adobe-campaign.svg": 85892,
	"./newletter/amazon-simple-email-service-amazon-ses.svg": 55184,
	"./newletter/autopilot.svg": 66109,
	"./newletter/aweber.svg": 50062,
	"./newletter/birdeye.svg": 28986,
	"./newletter/brevo.svg": 55240,
	"./newletter/bronto-marketing-platform.svg": 45957,
	"./newletter/campaign-monitor.svg": 8606,
	"./newletter/constant-contact.svg": 79283,
	"./newletter/dotdigital-engagement-cloud.svg": 43001,
	"./newletter/emarsys.svg": 89732,
	"./newletter/everest-formerly-250ok-and-return-path.svg": 11175,
	"./newletter/getresponse.svg": 24379,
	"./newletter/mail.svg": 37356,
	"./newletter/mailchimp.svg": 77086,
	"./newletter/mailerlite.svg": 60746,
	"./newletter/mailgun.svg": 1603,
	"./newletter/mailup.svg": 46507,
	"./newletter/marketo.svg": 75913,
	"./newletter/moosend.svg": 35670,
	"./newletter/outgrow.svg": 18483,
	"./newletter/sendgrid.svg": 36193,
	"./newletter/sendinblue.svg": 13095,
	"./newletter/sendpulse.svg": 46717,
	"./newletter/smtp2go.svg": 49704,
	"./newletter/twilio-sendgrid-email-api.svg": 29706,
	"./newletter/zoho-campaigns.svg": 6464,
	"./no.svg": 87390,
	"./notify/aws-lambda.svg": 65418,
	"./notify/aws-sns.svg": 45740,
	"./notify/aws-sqs.svg": 42423,
	"./notify/chrome-7.svg": 344,
	"./notify/onesignal.svg": 2157,
	"./notify/pusher.svg": 73215,
	"./packing_list.svg": 44281,
	"./packing_list_completed.svg": 33484,
	"./payments/Bonifico.svg": 62679,
	"./payments/Nexi_Logo.svg": 68752,
	"./payments/Paypal.svg": 15218,
	"./payments/Satispay2.svg": 47176,
	"./payments/amazonpay.svg": 20451,
	"./payments/bank.svg": 96694,
	"./payments/bank2.svg": 81330,
	"./payments/bank3.svg": 43919,
	"./payments/bank4.svg": 30113,
	"./payments/bank5.svg": 70349,
	"./payments/bank6.svg": 57132,
	"./payments/business-color_money-coins_icon-icons.com_53446.svg": 84601,
	"./payments/cashdelivery.svg": 83496,
	"./payments/clementine.svg": 48568,
	"./payments/contanti.svg": 96242,
	"./payments/crypto.svg": 85970,
	"./payments/dougs.svg": 70679,
	"./payments/freshbooks.svg": 11671,
	"./payments/georges.svg": 79579,
	"./payments/google-pay.svg": 84925,
	"./payments/googlepay.svg": 35842,
	"./payments/gpay.svg": 88996,
	"./payments/iconfinder__Mastercard_1156750.svg": 32641,
	"./payments/iconfinder__Western_Union_Logo_1156749.svg": 83234,
	"./payments/iconfinder_bitcoin_3838998.svg": 5681,
	"./payments/iconfinder_maestro_card_payment_358103.svg": 53854,
	"./payments/iconfinder_payment_method_google_wallet_206683.svg": 32230,
	"./payments/iconfinder_payu-money_742719.svg": 31376,
	"./payments/itool.svg": 22642,
	"./payments/klarna.svg": 10824,
	"./payments/klarna_icon.svg": 51581,
	"./payments/paypalcheckout/Single_Euro_Payments_Area_logo.svg": 65706,
	"./payments/paypalcheckout/code-svgrepo-com.svg": 8694,
	"./payments/paypalcheckout/grab.svg": 75889,
	"./payments/paypalcheckout/paypal_bancontact_color.svg": 92065,
	"./payments/paypalcheckout/paypal_blik_color.svg": 63522,
	"./payments/paypalcheckout/paypal_eps_color.svg": 36696,
	"./payments/paypalcheckout/paypal_giropay_color.svg": 56595,
	"./payments/paypalcheckout/paypal_ideal_color.svg": 98207,
	"./payments/paypalcheckout/paypal_mybank_color.svg": 15179,
	"./payments/paypalcheckout/paypal_poli_color.svg": 18722,
	"./payments/paypalcheckout/paypal_przelewy24_color.svg": 97794,
	"./payments/paypalcheckout/paypal_sofort_black.svg": 60442,
	"./payments/paypalcheckout/paypalcheckout.svg": 99464,
	"./payments/paypalcheckout/venmo-svgrepo-com.svg": 14011,
	"./payments/paytoshop.svg": 28264,
	"./payments/postepay.svg": 3341,
	"./payments/postepay2.svg": 45148,
	"./payments/quickbooks.svg": 57129,
	"./payments/satispay.svg": 63314,
	"./payments/satisplay.svg": 70163,
	"./payments/scalapay-seeklogo.svg": 98015,
	"./payments/scalapay.svg": 76287,
	"./payments/scalapay_icon.svg": 13430,
	"./payments/sellsy.svg": 65705,
	"./payments/shopify payments.svg": 89404,
	"./payments/stripe.svg": 44282,
	"./payments/wallet-passes-app.svg": 53474,
	"./payments/xero.svg": 96467,
	"./picture.svg": 80370,
	"./pp_fc_hl.svg": 11100,
	"./printer.svg": 5775,
	"./project/10-000ft.svg": 60368,
	"./project/accelo.svg": 83035,
	"./project/activecollab.svg": 78176,
	"./project/airtable.svg": 2858,
	"./project/apptivo.svg": 18878,
	"./project/asana.svg": 19411,
	"./project/avaza.svg": 30494,
	"./project/beesbusy.svg": 18921,
	"./project/celoxis.svg": 12793,
	"./project/citrix-podio.svg": 37337,
	"./project/clarizen-one.svg": 76481,
	"./project/clickup.svg": 51536,
	"./project/conceptdraw-project.svg": 754,
	"./project/easy-projects.svg": 29811,
	"./project/efficy.svg": 10679,
	"./project/float-float.svg": 43569,
	"./project/forecast-forecast.svg": 3516,
	"./project/freedcamp.svg": 71581,
	"./project/functionfox.svg": 45421,
	"./project/guidecx.svg": 66060,
	"./project/hive-2018-04-16.svg": 74122,
	"./project/inmotion-now-inmotionnow.svg": 58726,
	"./project/itm-platform.svg": 44749,
	"./project/kimble-psa.svg": 80965,
	"./project/liquidplanner.svg": 30365,
	"./project/mavenlink.svg": 88866,
	"./project/meisterplan.svg": 35552,
	"./project/meistertask.svg": 9632,
	"./project/microsoft-microsoft-project-portfolio-management.svg": 83876,
	"./project/mindgenius.svg": 54133,
	"./project/monday-com-monday-com.svg": 91288,
	"./project/nifty-technologies-inc-nifty.svg": 40918,
	"./project/odoo-project-management.svg": 62214,
	"./project/orangescrum.svg": 1501,
	"./project/paymo.svg": 13223,
	"./project/podio.svg": 28887,
	"./project/productive.svg": 79274,
	"./project/projectplace.svg": 94806,
	"./project/redbooth.svg": 4253,
	"./project/runrun-it.svg": 71351,
	"./project/scoro.svg": 67641,
	"./project/smartsheet.svg": 27109,
	"./project/sugarcrm.svg": 46333,
	"./project/swit.svg": 71939,
	"./project/taiga-agile-llc-taiga.svg": 26589,
	"./project/targetprocess.svg": 56090,
	"./project/taskray.svg": 7824,
	"./project/teamgantt.svg": 37244,
	"./project/teamwork-teamwork.svg": 10955,
	"./project/timehero.svg": 43400,
	"./project/toggl-plan.svg": 63732,
	"./project/unanet-a-e-powered-by-clearview.svg": 26029,
	"./project/workfront.svg": 90832,
	"./project/workzone.svg": 71502,
	"./project/wrike.svg": 50722,
	"./project/yuto.svg": 5129,
	"./project/zenkit.svg": 99242,
	"./project/zoho-projects.svg": 58866,
	"./salute-del-sito.svg": 68986,
	"./seo/facebookMarketplace.svg": 24435,
	"./seo/google-search-console.svg": 19545,
	"./service/aws.svg": 36747,
	"./service/fattureincloud.svg": 26626,
	"./service/fattureincloud2.svg": 47696,
	"./service/fattureincloud_active.svg": 25057,
	"./service/google_wallet_icon_133066.svg": 67769,
	"./service/google_wallet_logo_icon_132876.svg": 65871,
	"./shopify payments.svg": 5777,
	"./shopify_payments.svg": 11596,
	"./social/Facebook_icon.svg": 83992,
	"./social/facebook.svg": 52863,
	"./social/instagram.svg": 77602,
	"./social/tiktok.svg": 25186,
	"./star.svg": 83111,
	"./storage/amazon-cloudfront.svg": 39762,
	"./storage/amazon-s3.svg": 6431,
	"./storage/azure-1.svg": 21990,
	"./storage/azure-blob-storage.svg": 69964,
	"./storage/azure_content-delivery-network-cdn.svg": 21335,
	"./storage/google-cloud-storage.svg": 69414,
	"./storage/google_cdn.svg": 84446,
	"./store.svg": 96845,
	"./template/MDI - format-align-justify.svg": 52777,
	"./template/MDI - image-area.svg": 93606,
	"./template/alignleft.svg": 59247,
	"./template/alignright.svg": 63796,
	"./template/imagebottom.svg": 21846,
	"./template/imagetop.svg": 92527,
	"./template/multiimageleftalign.svg": 82876,
	"./template/multiimagerightalign.svg": 62814,
	"./tiktok.svg": 14044,
	"./tripadvisor.svg": 48482,
	"./video/3cx.svg": 27976,
	"./video/adobe-connect.svg": 5583,
	"./video/cisco-webex-meetings.svg": 10659,
	"./video/join-me.svg": 3863,
	"./video/lifesize.svg": 55204,
	"./video/livestorm.svg": 54317,
	"./video/skype.svg": 5592,
	"./video/spike.svg": 86106,
	"./video/teamviewer.svg": 50317,
	"./video/twilio.svg": 62724,
	"./video/webex-formerly-webex-teams.svg": 90754,
	"./video/youtube-3.svg": 89076,
	"./video/zoom.svg": 80129,
	"./visa.svg": 17676,
	"./warn.svg": 719,
	"./whatsapp.svg": 44511,
	"./www.svg": 88717,
	"./yes.svg": 35318,
	"./yoast.svg": 99298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29866;